export const LANGUAGE = {
  1: {
    alias: "zh-CN",
    name: "中文",
    title: ["中文", "中文"],
  },
  2: {
    alias: "en-US",
    name: "English",
    title: ["英文", "英文"],
  },
  3: {
    alias: "zh-HK",
    name: "繁体中文",
    title: ["繁体中文", "繁体中文"],
  },
};
